import axios from 'axios';
import $ from 'jquery'
import bus from './bus.js'
const privateConfig = require('../../private/config')
const BASE_URL = privateConfig.api.baseUrl
const isJQ = false

const axiosRequest = axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    // easy-mock服务挂了，暂时不使用了
    headers: {
        'Content-Type': 'application/json; charset=utf-8'
    },
    baseURL: BASE_URL,
    timeout: 30000
});
axiosRequest.interceptors.request.use(
    config => {
        const token = localStorage.getItem('Authorization');
        if (token) {
            config.headers = {
                'Authorization': token,
                'Content-Type': 'application/json; charset=utf-8'
            }
        }
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

axiosRequest.interceptors.response.use(
    response => {
        if (!response.data.success && (
            response.data.errorcode === '-10004'
            || response.data.errorcode === '-10003'
            || response.data.message === '没登录'
        )) {
            // location.href = '/#/login'
            localStorage.removeItem('Authorization')
            bus.$message.error('登录超时，请重新登录！');
            bus.$emit('goLogin')
            Promise.reject();
        }
        return response.data;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
)

const jqRequest = function (data = {}, type = 'json') {
    if (type === 'json') {
        return new Promise((resolve, reject) => {
            $.ajax({
                data: JSON.stringify(data.data),
                contentType: "application/json; charset=utf-8",
                xhrFields: {withCredentials: true},
                crossDomain: true,
                method: data.method,
                url: BASE_URL + data.url,
                beforeSend: function (xhr) {
                    const token = localStorage.getItem('Authorization');
                    xhr.setRequestHeader("Authorization", token);
                },
                success: (mes, textStatus, request) => {
                    if (!mes.success && mes.errorcode === '-10004') {
                        location.href = '/#/login'
                        localStorage.removeItem('Authorization')
                        bus.$message.error('登录超时，请重新登录！');
                    }
                    resolve(mes)
                },
                error: (err) => {
                    if (!err.success && err.errorcode === '-10004') {
                        location.href = '/#/login'
                        localStorage.removeItem('Authorization')
                        bus.$message.error('登录超时，请重新登录！');
                    }
                    reject(err)
                }
            })
        })
    } else {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'post',
				contentType: "application/x-www-form-urlencoded",
                data: data,
                cache: false,
                processData: false,
                // contentType: false,
                url: BASE_URL + data.url,
                beforeSend: function (xhr) {
                    const token = localStorage.getItem('Authorization');
                    xhr.setRequestHeader("Authorization", token);
                },
                success: (mes, textStatus, request) => {
                    if (!mes.success && mes.errorcode === '-10004') {
                        location.href = '/#/login'
                        localStorage.removeItem('Authorization')
                        bus.$message.error('登录超时，请重新登录！');
                    }
                    resolve(mes)
                },
                error: (err) => {
                    if (!err.success && err.errorcode === '-10004') {
                        location.href = '/#/login'
                        localStorage.removeItem('Authorization')
                        bus.$message.error('登录超时，请重新登录！');
                    }
                    reject(err)
                }
            })
        })
    }
    
}
export default isJQ ? jqRequest : axiosRequest